module.exports = __webpack_public_path__ + "static/media/umbrella-beach.bd04d099.svg";